import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogActions from "@material-ui/core/DialogActions";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";

import accountsService from "../../services/accountsService";
import DialogContainer from "../../containers/DialogContainer";
import { withFormik } from "formik";
import * as Yup from "yup";

class AddAccountDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      validateCalled: false,
      admin: false
    };
  }

  saveAccount = async () => {
    try {
      this.setState({
        fetching: true,
        confirmed: false
      });
      this.setState({ validateCalled: true });
      let isValid = await this.props.validateForm();
      console.log("valid", isValid);
      if (this.props.isValid) {
        let { firstname, lastname, email, tempPassword, admin } = this.props.values;
        let account = await accountsService.saveAccount({
          given_name: firstname,
          family_name: lastname,
          email: email,
          tempPassword: tempPassword,
          admin: admin
        });
        console.log(account);
        this.setState({
          fetching: false
        });
        this.props.handleClose(true);
      } else {
        this.setState({
          fetching: false
        });
      }
    } catch (err) {
      this.setState({ fetching: false });
      //  this.props.setFieldError("email", "Email is already taken");
    }
  };

  handleChangeAdmin = e => {
    console.log("check", e.target.checked);
    this.setState({
      admin: e.target.checked
    });
  };

  onExit = () => {
    this.setState({ validateCalled: false });
    this.props.resetForm();
  };
  render() {
    const { validateCalled } = this.state;
    const { handleChange, handleBlur, errors, values, touched, isValidating } = this.props;
    let account = values.admin ? "Admin Account" : "User Account";

    console.log("accouujnt", account);
    return (
      <DialogContainer
        open={this.props.open}
        onExit={this.onExit}
        title={`Add ${account}`}
        maxWidth="sm"
        contentText={`To add new account please enter the necessary information. Click "Save" to save the new account.`}
        actions={
          <DialogActions>
            <Button onClick={() => this.props.handleClose(false)} color="secondary">
              Cancel
            </Button>
            <Button onClick={this.saveAccount} color="primary">
              Save
              {this.state.fetching || isValidating ? <CircularProgress size={12} color="inherit" style={{ marginLeft: 5 }} /> : null}
            </Button>
          </DialogActions>
        }
      >
        {values.admin ? (
          ""
        ) : (
          <>
            <TextField
              autoComplete="off"
              id="firstname"
              helperText={(touched.firstname || validateCalled) && errors.firstname}
              error={(touched.firstname || validateCalled) && errors.firstname}
              value={values.firstname}
              onBlur={handleBlur}
              onChange={handleChange}
              label="Firstname"
              margin="normal"
              style={{ width: "100%", fontSize: "80px" }}
              variant="outlined"
            />
            <TextField
              autoComplete="off"
              id="lastname"
              value={values.lastname}
              helperText={(touched.lastname || validateCalled) && errors.lastname}
              error={(touched.lastname || validateCalled) && errors.lastname}
              onBlur={handleBlur}
              onChange={handleChange}
              label="Lastname"
              margin="normal"
              style={{ width: "100%", fontSize: "80px" }}
              variant="outlined"
            />
          </>
        )}
        <TextField
          autoComplete="off"
          id="email"
          value={values.email}
          helperText={(touched.email || validateCalled) && errors.email}
          error={(touched.email || validateCalled) && errors.email}
          onBlur={handleBlur}
          onChange={handleChange}
          label="Email"
          margin="normal"
          style={{ width: "100%", fontSize: "80px" }}
          variant="outlined"
        />
        <TextField
          autoComplete="off"
          id="tempPassword"
          value={values.tempPassword}
          helperText={(touched.tempPassword || validateCalled) && errors.tempPassword}
          error={(touched.tempPassword || validateCalled) && errors.tempPassword}
          onBlur={handleBlur}
          onChange={handleChange}
          label="Temporary Password"
          type="password"
          margin="normal"
          style={{ width: "100%", fontSize: "80px" }}
          variant="outlined"
        />
        <TextField
          autoComplete="off"
          id="confirmTempPassword"
          value={values.confirmTempPassword}
          helperText={(touched.confirmTempPassword || validateCalled) && errors.confirmTempPassword}
          error={(touched.confirmTempPassword || validateCalled) && errors.confirmTempPassword}
          onBlur={handleBlur}
          onChange={handleChange}
          label="Confirm Password"
          type="password"
          margin="normal"
          style={{ width: "100%", fontSize: "80px" }}
          variant="outlined"
        />
      </DialogContainer>
    );
  }
}

export default withFormik({
  mapPropsToValues: props => {
    console.log("props", props);
    return {
      firstname: "",
      lastname: "",
      email: "",
      tempPassword: "",
      confirmTempPassword: "",
      admin: props.type === "Admin" ? true : false
    };
  },
  validationSchema: Yup.object().shape({
    firstname: Yup.string().when("admin", {
      is: false, // alternatively: (isBig, isSpecial) => isBig && isSpecial
      then: Yup.string().required("Firstname is required!")
    }),
    lastname: Yup.string().when("admin", {
      is: false,
      then: Yup.string().required("Lastname is required!")
    }),
    email: Yup.string()
      .email("Please give a valid email address")
      .required("Email is required!"),
    tempPassword: Yup.string()
      .required("Temporary Password is required!")
      .matches(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/, "Password must be at least 8 letters, uppercase, lowercase and numbers."),
    confirmTempPassword: Yup.string()
      .required("Password confirmation is required!")
      .oneOf([Yup.ref("tempPassword"), null], "Password does not match!")
  }),
  enableReinitialize: true,
  validateOnChange: true
})(AddAccountDialog);
